import { render, staticRenderFns } from "./OutstandingArtworks.vue?vue&type=template&id=7ac285a2&scoped=true"
import script from "./OutstandingArtworks.vue?vue&type=script&lang=js"
export * from "./OutstandingArtworks.vue?vue&type=script&lang=js"
import style0 from "./OutstandingArtworks.vue?vue&type=style&index=0&id=7ac285a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac285a2",
  null
  
)

export default component.exports